/* eslint-disable camelcase */
import findGeneralSceneName from 'schemas/migrator/helpers/findGeneralSceneName'
import { FOV_PREVIEW_HEIGHT, FOV_PREVIEW_WIDTH } from 'helpers/globals'
import { defaults } from 'helpers/cameras/coreCameraProps'
import { stringToBoolean } from './general'

const defaultBackgroundPosition = fov_position => {
  console.log(`WARNING: backgroundPosition could not be migrated: ${fov_position}`)
  return defaults.backgroundPosition
}

const calculateFovPosition = fov_position => {
  if (!fov_position) return defaultBackgroundPosition(fov_position)

  const [legacyX, legacyY] = fov_position.split(' ').map(parseFloat)
  if ([legacyX, legacyY].some(n => isNaN(n))) return defaultBackgroundPosition(fov_position)

  const legacyPreviewWidth = 400
  const legacyPreviewHeight = 300
  const widthRatio = FOV_PREVIEW_WIDTH / legacyPreviewWidth
  const heightRatio = FOV_PREVIEW_HEIGHT / legacyPreviewHeight

  return { backgroundPositionX: legacyX * widthRatio, backgroundPositionY: legacyY * heightRatio }
}

export default (fov_image, fov_position, fov_image_is_user_selected) => {
  const common = {
    streetViewActive: false,
    userSelectedGeneralScene: !!stringToBoolean(fov_image_is_user_selected),
    backgroundPosition: calculateFovPosition(fov_position)
  }

  return Object.assign(
    common,
    { sceneName: findGeneralSceneName(fov_image) },
    fov_image.includes('composite') && { userUploadedSceneUrl: fov_image, userUploadedSceneActive: true }
  )
}



// WEBPACK FOOTER //
// ./src/schemas/migrator/helpers/sceneInfo.js